export const getCurrentUserDataAttribute = <P>(
  attribute: string
): P | undefined => {
  try {
    const currentUser = document
      .getElementById('bb-bootstrap')
      ?.getAttribute('data-current-user');

    // Try catch included for edge cases where the data is not valid JSON
    return currentUser
      ? (JSON.parse(currentUser)?.[attribute] as P)
      : undefined;
  } catch {
    return undefined;
  }
};
